import React, { useState } from 'react';
import { connect } from 'react-redux';
import { NotificationBar } from 'react-lib/dist/components-es';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { initSelectors } from '../../behavior/init';
import { lmsCoursesActions } from '../../behavior/lmsCourses';
import { useOnce } from 'react-lib/dist/hooks-es';
import useUser from '@behavior/init/getUserV2';

const LmsCourseToExpireNotificationBarComponent = ({
  getRequiredLmsCourses,
  requiredLmsCourses,
  t,
}) => {
  const { user } = useUser();
  const [isNotificationBarShown, updateIsNotificationBarShown] = useState(true);

  useOnce(() => {
    if (!initSelectors.isPublic(user)) getRequiredLmsCourses();
  });

  return (
    <>
      {requiredLmsCourses &&
        requiredLmsCourses.find(c => c.isAboutToExpire) &&
        isNotificationBarShown && (
          <NotificationBar
            notificationText={t('required.lms.courses.is.about.to.expire.notification.bar.message')}
            updateIsNotificationBarShown={updateIsNotificationBarShown}
          />
        )}
    </>
  );
};

const mapStateToProps = state => ({
  ...state.lmsCourses,
});

const mapDispatchToProps = dispatch => ({
  getRequiredLmsCourses: () => dispatch(lmsCoursesActions.getRequiredLmsCourses()),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation()
)(LmsCourseToExpireNotificationBarComponent);
